import { render } from "./IntegrateAPI.vue?vue&type=template&id=4a83ded6&scoped=true"
const script = {}

import "./IntegrateAPI.vue?vue&type=style&index=0&id=4a83ded6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a83ded6"]])

export default __exports__